export interface HighlightedTextSegment {
  text: string;
  isMatch: boolean;
}

export const splitForHighlight = (text: string, query: string): HighlightedTextSegment[] => {
  const trimmedQuery = query.trim();
  if (!trimmedQuery) {
    return [{ text, isMatch: false }];
  }

  const segments: HighlightedTextSegment[] = [];
  const lowerText = text.toLowerCase();
  const lowerQuery = trimmedQuery.toLowerCase();
  const queryLength = lowerQuery.length;

  let cursor = 0;
  let matchIndex = lowerText.indexOf(lowerQuery, cursor);

  while (matchIndex !== -1) {
    if (matchIndex > cursor) {
      segments.push({ text: text.slice(cursor, matchIndex), isMatch: false });
    }
    segments.push({ text: text.slice(matchIndex, matchIndex + queryLength), isMatch: true });
    cursor = matchIndex + queryLength;
    matchIndex = lowerText.indexOf(lowerQuery, cursor);
  }

  if (cursor < text.length) {
    segments.push({ text: text.slice(cursor), isMatch: false });
  }

  return segments.length > 0 ? segments : [{ text, isMatch: false }];
};
